import SuperFetch, { AbortSuperFetch } from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';
import { getAttributes } from '../helpers/urlBuilder';

const { build } = UrlBuilder;

type ApiReqWithParam = (params: getAttributes) => Promise<Response>;
type ApiReqWNoParam = () => Promise<Response>;
/**
 * Klasa zawiera metody służące wysyłaniu zapytań o dane do zakładki Moje Przedmioty do API
 *
 */
class MySubjects {
  /** Pobieranie kontentu dla tabeli "Moje przedmioty" */
  getMySubjects = ({ page, ...rest }: getAttributes, signal: AbortSignal, withCache = false): Promise<Response> => {
    const params: getAttributes = {
      page: page.toString(),
      limit: '500',
      noCache: withCache ? true.toString() : false.toString(),
      ...rest,
    };
    const address: string = build('przedmiot/ztn_przydzialy', params);
    return AbortSuperFetch.get(address, signal);
  };
  /** pobranie szczegółów przedmiotu w zakładce pojedynczego studenta */
  getMySubjectDetailsInStudentPage: ApiReqWithParam = ({ columns, id, semestr }) => {
    const params: getAttributes = {
      columns,
    };
    const address: string = build(`student/ztn_pojedyczny_student_przydzial/${id}/${semestr}`, params);
    return SuperFetch.get(address);
  };
  /** pobranie szczegołów rekordu */
  getMySubjectDetails: ApiReqWithParam = ({ columns, id, filter }) => {
    const params: getAttributes = {
      columns,
      filter,
    };
    const address: string = build(`przedmiot/ztn_przydzialy_pojedyczny/${id}`, params);
    return SuperFetch.get(address);
  };
  /** pobranie listry dostępnych filtrów */
  getMySubjectsFilterList: ApiReqWNoParam = () => SuperFetch.get('przedmiot/ztn_przydzial_field_filter');
  /** pobranie listy wartości filtrów */

  refreshFilterValues = (params: FilterValuePayload, signal: AbortSignal): Promise<Response> => {
    const address: string = build('przedmiot/ztn_przydzial_multi_filter_value', params);
    return AbortSuperFetch.get(address, signal);
  };
  /** pobranie konfiguracji kolumn */
  getMySubjectsColumnsData: ApiReqWNoParam = () => SuperFetch.get(`przedmiot/ztn_przedmiot_without_student_config`);
  /** ustawienie konfiguracji kolumn */
  saveColumnsUserSetup: ApiReqWithParam = ({ columnsSetup }) => {
    const payload = {
      data: JSON.stringify(columnsSetup),
    };
    return SuperFetch.put('uc/user-config/cs_przydzial_prz', payload);
  };
}

export default new MySubjects();
